import { NumberFieldFormikField } from "@certn/cascadia-react";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { Stack, Text } from "@certn/cascadia";

interface Props {
  checkArguments?: {
    minimum?: number;
    maximum?: number;
  };
  isReadOnly?: boolean;
}

export function CredentialDetails(props: Props) {
  const { checkArguments, isReadOnly } = props;

  return (
    <>
      <Stack gap="space-0">
        <Text style="form/section-heading">
          <Trans>Requirements</Trans>
        </Text>
        <Text style="form/body-secondary">
          <Trans>
            Configure the minimum and maximum number of credentials required for
            a background check.
          </Trans>
        </Text>
      </Stack>
      <NumberFieldFormikField
        name="check_arguments.minimum"
        testID="minimum-credentials"
        isRequired
        isReadOnly={isReadOnly}
        isDisabled={isReadOnly}
        label={t("Minimum required")}
        minValue={1}
        maxValue={checkArguments?.maximum}
      />
      <NumberFieldFormikField
        name="check_arguments.maximum"
        testID="maximum-credentials"
        isRequired
        isReadOnly={isReadOnly}
        isDisabled={isReadOnly}
        label={t("Maximum required")}
        minValue={checkArguments?.minimum}
        maxValue={10}
      />
    </>
  );
}
